import { useMemo } from "react";
import { publicAddress } from "../utils/localData";
import { useGetUserQuery } from "../redux/slices/api/userApi";
import { useSelector } from "react-redux";
import { selectGeneral } from "../redux/slices/generalSlice";

const useCheckProjectPermissions = ({ projectData }) => {
  const { isLoggedIn } = useSelector(selectGeneral);
  
  // Get current user data
  const { data: meData } = useGetUserQuery(null, {
    skip: !isLoggedIn,
  });

  const currentUser = meData?.user;
  const { collaborators, creator } = projectData ?? {};

  // This function checks if the current user is a collaborator or the creator of the project.
  // First checks by user ID (for account-based login), falls back to public_address (for wallet-only users)
  const hasAccessToResult = useMemo(() => {
    if (projectData && currentUser) {
      const currentUserId = currentUser?._id;
      const currentUserAddress = currentUser?.public_address || publicAddress();
      
      // Check if user is creator (by ID or by public address)
      const isCreator = 
        creator?._id === currentUserId || 
        creator?.public_address === currentUserAddress;
      
      // Check if user is a collaborator (by ID or by public address)
      const isCollaborator = collaborators?.some(
        (item) => 
          item?._id === currentUserId || 
          item?.public_address === currentUserAddress
      );
      
      return isCreator || isCollaborator;
    }
    return false;
    // eslint-disable-next-line
  }, [projectData, currentUser]);

  // This function checks if the current user is the creator of the project.
  // Checks by user ID (for account-based login), falls back to public_address (for wallet-only users)
  const hasAccessToProject = useMemo(() => {
    if (projectData && currentUser) {
      const currentUserId = currentUser?._id;
      const currentUserAddress = currentUser?.public_address || publicAddress();
      
      return (
        creator?._id === currentUserId || 
        creator?.public_address === currentUserAddress
      );
    }
    return false;
    // eslint-disable-next-line
  }, [projectData, currentUser]);

  return {
    hasAccessToProject,
    hasAccessToResult,
  };
};

export default useCheckProjectPermissions;